import i18next from 'i18next';
import {EVENT} from '../../../common/events/listEvents';

export default class AlertComponentAction {

    static translate(key) {
        return i18next.t(key)
    }
    /**
     * 
     * @param {*} text 
     */
    static openAlert(text, className, isShowCloseIcon, actionYes) {
        window.alertComp = {};
        window.alertComp.message = text;
        window.alertComp.className = className ? className : 'alert'
        window.alertComp.isShowCloseIcon = isShowCloseIcon;
        window.alertComp.actionYes = actionYes;
        window.fireEvent(EVENT.OPEN_ALERT);
    }

    /**
     * @param {*} message 
     * @param {*} actionYes 
     * after click ok, will do next function
     */
    static openAlertCallBack(text, actionCallBack, className, title, isShowCloseIcon) {
        window.alertComp = {};
        window.alertComp.message = text;
        window.alertComp.title = title;
        window.alertComp.actionYes = actionCallBack;
        window.alertComp.className = className ? className : 'alert_call_back'
        window.alertComp.isShowCloseIcon = isShowCloseIcon;
        window.fireEvent(EVENT.OPEN_ALERT);
    }
    /**
     * 
     * @param {*} message 
     * @param {*} actionYes //action of Yes Button
     */
    static openConfirm(message, actionYes, className, isShowCloseIcon) {
        window.alertComp = {};
        window.alertComp.message = message;
        window.alertComp.actionYes = actionYes;
        window.alertComp.isConfirmAlert = true;
        window.alertComp.className = className ? className : 'confirm'
        window.alertComp.isShowCloseIcon = isShowCloseIcon;
        window.fireEvent(EVENT.OPEN_ALERT);
    }

    /**
     * 
     * @param {*} message 
     * @param {*} actionYes //action of Yes Button
     * @param {*} btnYesText //label of Yes Button
     * @param {*} actionNo  //action of No Button
     * @param {*} btnNoText //label of No Button
     */
    static openAdvanceConfirm(message, actionYes, btnYesText, actionNo, btnNoText, className, isShowCloseIcon) {
        window.alertComp = {};
        window.alertComp.message = message;
        window.alertComp.actionYes = actionYes;
        window.alertComp.btnYesText = btnYesText;
        window.alertComp.actionNo = actionNo;
        window.alertComp.btnNoText = btnNoText;
        window.alertComp.isConfirmAlert = true;
        window.alertComp.isShowCloseIcon = isShowCloseIcon;
        if (!(typeof className == "undefined" || className == null)) {
            window.alertComp.className = className;
        }
        window.fireEvent(EVENT.OPEN_ALERT);
    }

    static openNewAdvanceConfirm(title, message, actionYes, btnYesText, actionNo, btnNoText, className = '', isShowCloseIcon) {
        window.alertComp = {
            title,
            message,
            actionYes,
            btnYesText,
            actionNo,
            btnNoText,
            className,
            isConfirmAlert: true,
            isShowCloseIcon
        };
        window.fireEvent(EVENT.OPEN_ALERT);
    }

    static openAdvanceConfirmWithTitle(title, message, actionYes, btnYesText, className, isShowCloseIcon) {
        window.alertComp = {};
        window.alertComp.title = title;
        window.alertComp.message = message;
        window.alertComp.actionYes = actionYes;
        window.alertComp.btnYesText = btnYesText;
        window.alertComp.isShowCloseIcon = isShowCloseIcon;
        if (!(typeof className == "undefined" || className == null)) {
            window.alertComp.className = className;
        }
        window.fireEvent(EVENT.OPEN_ALERT);
    }

    static actionTest() {
        alert("Hello");
        window.fireEvent(EVENT.CLOSE_ALERT);
    }

    static closeAlert() {
        window.fireEvent(EVENT.CLOSE_ALERT);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/BaseComponent/AlertComponent/AlertComponentAction.js